import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';

import * as UserActions from './user.actions';
import * as UserSelectors from './user.selectors';
import { Observable } from 'rxjs';

@Injectable()
export class UserFacade {
  constructor(private readonly store: Store) {}

  public getUserId(): Observable<string | null> {
    return this.store.pipe(select(UserSelectors.getUserIdState()));
  }

  public initUser(userId: string): void {
    this.store.dispatch(UserActions.initUser({ userId }));
  }
}
